var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUartModbusCommandType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.87 224.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6fccdd;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #97d3bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.68,
    y: 5.28,
    width: 122.7,
    height: 78.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.61,
    y: 83.58,
    width: 5.01,
    height: 49.52,
    transform: "translate(202.24 216.69) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 139.52,
    y: 83.58,
    width: 5.01,
    height: 95.75,
    transform: "translate(284.05 262.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.3,
    y: 129.81,
    width: 5.01,
    height: 49.52,
    transform: "translate(61.61 309.15) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.31,
    y: 93.8,
    width: 3.29,
    height: 75.32,
    transform: "translate(197.42 65.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 250.56,
    y: 129.81,
    width: 5.01,
    height: 49.52,
    transform: "translate(506.13 309.15) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 180.24,
    y: 83.58,
    width: 5.01,
    height: 49.52,
    transform: "translate(365.5 216.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.26,
    y: 93.8,
    width: 3.29,
    height: 75.32,
    transform: "translate(86.45 349.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.38,
    y: 168.63,
    width: 50.84,
    height: 50.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 227.64,
    y: 168.63,
    width: 50.84,
    height: 50.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.51,
    y: 168.63,
    width: 50.84,
    height: 50.84
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.38,5.38v78.18h-18.11v46.16h70.3v38.81h22.92v50.84h-50.84v-50.84h22.92v-35.53h-70.32v-49.45h-35.71v84.97h22.81v50.84h-50.83v-50.84h23.01v-84.97h-35.9v49.45H33.3v35.53h22.92v50.84H5.38v-50.84h22.92v-38.81h70.32v-46.16h-17.93V5.38h122.69M208.76,0H75.31v88.94h17.93v35.4H22.92v38.81H0v61.6h61.6v-61.6h-22.92v-24.77h70.32v-49.45h25.14v74.21h-23.01v61.6h61.59v-61.6h-22.81v-74.21h24.95v49.45h70.32v24.77h-22.92v61.6h61.6v-61.6h-22.92v-38.81h-70.3v-35.4h18.11V0h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUartModbusCommandType);
export default __webpack_public_path__ + "static/media/uart-modbus-command-type.8db2a2c6e5c47fe4b7fb6ac8b64f7e53.svg";
export { ForwardRef as ReactComponent };